var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign"},[_c('div',{staticClass:"siandiv"},[_c('div',{staticClass:"signline"}),_c('div',{staticClass:"signicon"}),_c('div',{staticClass:"signtxt"}),_c('div',{staticClass:"signbtn"},[_c('button',[_vm._v("我要签到")])])]),_c('div',{staticClass:"maskbg"})])
}]

export { render, staticRenderFns }